module.exports = __webpack_public_path__ + "static/amirka.7400fbf0f61be1fe248e34354ac5e5a1.jpeg";